import * as React from "react";
import { Toaster, toast } from 'sonner';

export default function MSSToasterHost() {
  return (
    <Toaster
      position="bottom-right"
      richColors
      closeButton
      className="z-50"
    />
  );
}